export default __webpack_public_path__ + "static/media/lesnik_winter_b_03.95eab5af.svg";